import { useNavigate, useSearchParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useMagicLinkRedirect } from '@foundation-bb/foundation-auth-ui';
import { Spinner } from '@/ui';
import { env } from '@/env';
import * as layout from '@/styles/layout.css';
import * as authStatus from './authStatus.css';

// The invitation / login magic-link email lands here. We can't verify via fetch
// (the success path is a 302 that sets an HttpOnly refresh cookie and carries the
// access token in the redirect fragment — both invisible to JS), so Foundation's
// useMagicLinkRedirect hands the browser off to the Function App via a top-level
// navigation. The API verifies the token, sets the cookie, and 302s back to
// /auth/complete#access_token=... on this SPA. A missing token → styled error page.
export default function MagicLinkPage() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const token = params.get('token');

  useMagicLinkRedirect({
    apiBase: env.api.baseUrl,
    token,
    onMissingToken: () => navigate('/auth/error?code=invalid_link', { replace: true }),
  });

  return (
    <div className={layout.centerBoth} style={{ minHeight: '100vh' }}>
      <Spinner size="sm" /> <span className={authStatus.spinnerLabel}>{t('callback.loading')}</span>
    </div>
  );
}
